module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [(_vm.show) ? _c('span', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-2x"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09f63054!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/spinner.vue
// module id = 132
// module chunks = 0